<template>
    <qb-panel :title="titulo.toUpperCase()" class="qb-margin-top">
      <vue-element-loading :active="!this.listaPronta"/>
      <card-group size="5" v-if="!vazio">
        <qb-card v-for="produto in produtos" :key="produto.id" :content="produto" v-on:card-click="show(produto.id)">
            <template v-slot:image>
              <!-- <carousel :autoplay="true" :nav="false" :items="1" v-if="produto.images.length">
                <img v-for="(imagem, index) in produto.images" :key="index" :src="imagem" alt="foto produto" style="max-width: 80px;max-height: 80px;min-height: 80px;"/>
              </carousel> -->
              <img v-if="produto.images.length" :src="produto.images[0]" alt="foto produto"/> 
              <img v-else src="@/assets/sem-foto.png" alt="foto produto"/>
          </template>
          <button class="btn btn-primary btn-full">Adicionar</button>
        </qb-card>
      </card-group>
      <div v-if="vazio">
        <h3>Nenhum resultado para {{ this.$route.query.params }}</h3>
      </div>
        <paginate v-if="!vazio"
          :pageCount= paginas
          :prev-text="'Anterior'"
          :next-text="'Próximo'"
          :force-page= paginaAtual
          :container-class="'pagination'"
          :page-class="'page-item'"
          :clickHandler="clickCallback">
        </paginate>
        <div style="display: flex;width: 100%;justify-content: center;">
          <p v-if="vazio">Página - de -</p>
          <p v-else>Página {{paginaAtual}} de {{paginaAtual > 0 && paginas == 0 ? "1" : paginas}}</p>
        </div>
    <modal v-for="produto in produtos" :key="produto.id" :name="produto.id" :adaptive="true" height="auto" :resizable="true" :scrollable="true" >
      <conteudo-modal-produto v-bind="produto" :idModal="produto.id"/>
    </modal>
    </qb-panel>
</template>

<script>
import axios from "axios";
import { baseApiUrl, baseImage } from "@/global";
import CardGroup from '../../components/card/card-group.vue';
import QbCard from '../../components/card/card.vue';
import ConteudoModalProduto from '../../components/modal/product-modal.vue';
import Paginate from 'vuejs-paginate';
import VueElementLoading from 'vue-element-loading';
//import carousel from 'vue-owl-carousel';

export default {
name: 'Lista',
  components: {
    CardGroup,
    QbCard,
    ConteudoModalProduto,
    Paginate,
    VueElementLoading,
    //carousel
    },
    data(){
        return{
          produtos: [],
          titulo: (this.$route.query.ofertas ? 'Ofertas' :this.$route.query.novidades ? 'Novidades' :'Lista de produtos'),
          paginas: 0,
          paginaAtual: 0,
          listaPronta: false,
          vazio: false,
          baseImage: baseImage
        }
    },
    methods: {
      clickCallback(pageNum){
        this.$router.push({ name: 'lista', query:{ 
          marcas: this.$route.query.marcas, 
          params: this.$route.query.params, 
          pagina: pageNum,
          idCategoria: this.$route.query.idCategoria,
          ofertas: this.$route.query.ofertas,
          novidades: this.$route.query.novidades,
          especificacao: this.$route.query.especificacao,
          peso: this.$route.query.peso,
          tamanho: this.$route.query.tamanho
          }})
      },
      carregarProdutos(){ 
             let url = `${baseApiUrl}/products/list/?page=${ this.$route.query.pagina ? this.$route.query.pagina : 1 }&brands=${ this.$route.query.marcas ? this.$route.query.marcas: '' }&param=${ this.$route.query.params ? this.$route.query.params : '' }&IdCategory=${ this.$route.query.idCategoria ? this.$route.query.idCategoria : 0 }&news=${ this.$route.query.novidades ? true : false }&offers=${ this.$route.query.ofertas ? true : false }&specifications=${ this.$route.query.especificacao ? this.$route.query.especificacao : ''}`;
             url += (this.$route.query.peso != '0|1700' ? `&peso=${ this.$route.query.peso ? this.$route.query.peso : ''}` : ``);
             url += (this.$route.query.tamanho != '0|2000' ? `&tamanho=${ this.$route.query.tamanho ? this.$route.query.tamanho : ''}`: ``);
             url += (this.$route.query.vazao != '0|2000' ? `&vazao=${ this.$route.query.vazao ? this.$route.query.vazao : ''}`: ``);

             axios.get(url)
              .then(res => {
                if (res.status == 204) {
                  this.vazio = true
                  this.listaPronta = true;
                  return
                }
                this.paginas = res.data.pages;
                this.paginaAtual = res.data.currentPage;
                this.produtos = res.data.products;
                // this.titulo =  this.$route.query.params ? 'resultados para ' + this.$route.query.params : this.$route.params.categoria;
                this.listaPronta = true;
                this.vazio = false
              }).catch(() =>{
                this.listaPronta = true;
              });
        },
        show (id) {
          this.$modal.show(id);
        }
    },
    beforeRouteUpdate (to, from, next) {
      this.listaPronta = false;
      this.paginaAtual = parseInt(to.query.pagina);
      next();
      this.carregarProdutos();
    },
    created(){
        this.carregarProdutos();
    },
}
</script>

<style>
.pagination {
  display: flex;
  justify-content: space-between;
  list-style: none;
  align-items: center;
}

.pagination li a{
    border: 1px solid black;
    padding: 8px 16px;
    margin: 0px 8px 0 0;
}

.page-item.active a{
  background-color: rgb(32, 176, 169);
  color: white;
}

.disabled a {
  color: white;
  background-color: black;
  cursor: not-allowed;
  opacity: 0.2;
}

li.page-item{
  display: none;
}
</style>
